import {
  DialogTitle,
  Typography,
  Button,
  IconButton,
  styled,
} from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const DialogTitleCustom = styled(DialogTitle)(() => ({
  height: pxToRem(50),
  padding: pxToRem(16),
  position: "relative",
  textAlign: "center",

  button: {
    position: "absolute",
    top: pxToRem(8),
    right: pxToRem(8),
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.md_16,
  fontWeight: theme.typography.fw_semibold_600,
  color: theme.palette.text.textPrimary,
}));

export const ButtonCustom = styled(Button)(() => ({
  width: "100%",
}));

export const Avatar = styled("img")(() => ({
  width: pxToRem(300),
  height: pxToRem(300),
  objectFit: "cover",
  borderRadius: "50%",
}));

export const ImageBirthday = styled("img")(() => ({
  width: pxToRem(300),
  height: pxToRem(300),
  objectFit: "cover",
  borderRadius: "6px",
}));

export const ImageBirthdayWrapper = styled("div")(() => ({
  position: "relative",
  width: pxToRem(300),
  height: pxToRem(300),
}));

export const DeleteImageButton = styled(IconButton)(() => ({
  position: "absolute",
  top: pxToRem(8),
  right: pxToRem(8),
  width: pxToRem(28),
  height: pxToRem(28),
  padding: 0,
  backgroundColor: "#fff",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",

  "&:hover": {
    backgroundColor: "#fff",
  },
}));

export const CropContainer = styled("div")(() => ({
  position: "relative",
  width: pxToRem(300),
  height: pxToRem(300),
  borderRadius: pxToRem(6),
  overflow: "hidden",
  background: "#333",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));
